import { MEDIA } from "../lib/api";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-24">
      <section className="max-w-[1100px] mx-auto px-6 md:px-12">
        <div className="overline mb-8">About CHICA</div>
        <h1 className="font-display text-5xl sm:text-7xl text-[#F9F6F0] leading-[1.05] max-w-3xl">
          Where culinary artistry meets the Himalayas.
        </h1>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 mt-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-7 img-zoom aspect-[4/5]">
          <img src={MEDIA.interior} alt="CHICA dining room" className="w-full h-full object-cover" />
        </div>
        <div className="md:col-span-5 self-end">
          <div className="overline mb-4">Welcome</div>
          <h2 className="font-display text-3xl text-[#F9F6F0]">
            A sanctuary of fine dining, vibrant nightlife, and impeccable design.
          </h2>
          <p className="mt-6 text-[#9AA894] leading-relaxed">
            Welcome to CHICA Dehradun, where culinary artistry meets the
            breathtaking beauty of the Himalayas. Perched elegantly on Rajpur
            Road, our space is designed to be more than just a restaurant; it
            is a sanctuary for those who appreciate fine dining, vibrant
            nightlife, and impeccable design. Whether you are joining us for a
            sun-drenched brunch on our rooftop or a high-energy evening under
            the neon lights of our lounge, CHICA offers an atmosphere that is
            both sophisticated and soulful.
          </p>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 mt-32 grid md:grid-cols-12 gap-12 items-end">
        <div className="md:col-span-5">
          <div className="overline mb-4">The kitchen</div>
          <h2 className="font-display text-4xl text-[#F9F6F0] leading-tight">
            A curated journey across continents.
          </h2>
          <p className="mt-6 text-[#9AA894] leading-relaxed">
            Our menu is a curated journey across continents, bringing together
            the bold spices of North India with the delicate finesse of Asian
            and Mediterranean flavors. From our signature Himalayan Trout to
            artisanal cocktails crafted by master mixologists, every dish is
            prepared with the freshest local ingredients and a passion for
            innovation. At CHICA, we believe every meal should be a celebration,
            served with a side of stunning mountain views and world-class
            hospitality.
          </p>
        </div>
        <div className="md:col-span-7 img-zoom aspect-[16/10]">
          <img src={MEDIA.bar} alt="CHICA bar" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 mt-32 grid md:grid-cols-12 gap-12 items-end">
        <div className="md:col-span-7 img-zoom aspect-[16/10]">
          <img src={MEDIA.atrium} alt="CHICA atrium" className="w-full h-full object-cover" />
        </div>
        <div className="md:col-span-5">
          <div className="overline mb-4">The space</div>
          <h2 className="font-display text-4xl text-[#F9F6F0] leading-tight">
            MediterrAsian charm. Pinterest-worthy interiors.
          </h2>
          <p className="mt-6 text-[#9AA894] leading-relaxed">
            Step into a world of "MediterrAsian" charm, where Pinterest-worthy
            interiors and rhythmic beats create the perfect backdrop for your
            most memorable moments. Whether you're planning a romantic date,
            a family gathering, or a night out with friends, CHICA Dehradun is
            the ultimate destination for those who seek the extraordinary.
            Experience the fusion of taste, style, and spirit — only at the
            city's most iconic social hub.
          </p>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 mt-32 pt-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            ["04", "Cuisines"],
            ["12—22", "Open daily"],
            ["15%", "Dining discount"],
            ["1", "Iconic address"],
          ].map(([n, l]) => (
            <div key={l}>
              <div className="font-display text-5xl text-[#D4C1A0]">{n}</div>
              <div className="overline mt-3">{l}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
